/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { AiOutlineFileText } from 'react-icons/ai';
import { displayDocVersion, ROUTES } from '../../assets/constants/strings';
import { FaChevronRight } from 'react-icons/fa';
import { BsFillFolderSymlinkFill } from 'react-icons/bs';

const PaginatedList = ({
  DisplayList,
  handleSetDocument,
  selectedItem,
  handleSelectedLevel,
}) => {
  const [itemsPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);

  const handlePaginationClick = (item) => {
    setSelectedPage(item.selected + 1);
  };

  const pageCount = Math.ceil(DisplayList.length / itemsPerPage);
  const indexOfLastItem = selectedPage * itemsPerPage;
  const indexOfFirstTodo = indexOfLastItem - itemsPerPage;
  const selectedList = DisplayList.slice(indexOfFirstTodo, indexOfLastItem);

  const documentList = DisplayList.filter(
    (item) => item.itemType === 'Document'
  )
    .sort((a, b) =>
      a.Document.title
        .trim()
        .localeCompare(b.Document.title.trim(), undefined, {
          numeric: true,
        })
    )
    .slice(indexOfFirstTodo, indexOfLastItem);

  useEffect(() => {
    setSelectedPage(1);
  }, [DisplayList]);

  return (
    <div className='doc-wrapper__content__list'>
      {selectedList.length > 0 ? (
        <React.Fragment>
          {selectedList
            .filter((item) => item.itemType === 'LevelItem')
            .sort((a, b) => (a.LevelItem.Sort > b.LevelItem.Sort ? 1 : -1))
            .map(({ LevelItem }, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectedLevel(LevelItem)}
                  className={`doc-wrapper__content__list__item${
                    selectedItem && selectedItem.ID === LevelItem.ID
                      ? ' item-active'
                      : ''
                  }`}
                >
                  <div className='d-flex align-items-center'>
                    <BsFillFolderSymlinkFill className='file-icon' />
                    <span>{LevelItem.Title}</span>
                  </div>
                  <FaChevronRight className='arrow-icon' />
                </div>
              );
            })}
          {documentList.map(({ Document }, i) => {
            return (
              <Link
                key={i}
                to={ROUTES.DOCUMENT(Document.slug)}
                // to={ROUTES.HOME}
                onClick={() => handleSetDocument(Document.slug)}
                className='doc-wrapper__content__list__item'
              >
                <div className='d-flex align-items-center'>
                  <AiOutlineFileText className='file-icon' />
                  <span>{displayDocVersion(Document)}</span>
                </div>
              </Link>
            );
          })}
          {pageCount > 1 && (
            <div className='text-center mt-3 pb-4 mx-auto'>
              <ReactPaginate
                onPageChange={handlePaginationClick}
                previousLabel={'previous'}
                previousClassName={'paginate-previous'}
                nextLabel={'next'}
                nextClassName={'paginate-next'}
                breakLabel={'...'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={10}
                containerClassName={'pagination pagination-sm'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                activeClassName={'page-item active'}
              />
            </div>
          )}
        </React.Fragment>
      ) : (
        // if there isn't
        <div
          className='alert alert-danger'
          role='alert'
          aria-label='No Documents'
        >
          No matching documents found.
        </div>
      )}
    </div>
  );
};

export default PaginatedList;
